/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';

/**
 * A command used to modify the simple property of a node.  Should not be used
 * to modify complex (object) properties, only simple property types like
 * string, boolean, number, etc.
 * 
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ChangePropertyCommand<T> extends AbstractCommand {
    public _nodePath : NodePath;

    public _property : string;

    public _newValue : T;

    public _oldValue : T;

    public constructor(node? : any, property? : any, newValue? : any) {
        if(((node != null && node instanceof <any>Node) || node === null) && ((typeof property === 'string') || property === null) && ((newValue != null) || newValue === null)) {
            let __args = arguments;
            super();
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._property===undefined) this._property = null;
            if(this._newValue===undefined) this._newValue = null;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._property===undefined) this._property = null;
            if(this._newValue===undefined) this._newValue = null;
            if(this._oldValue===undefined) this._oldValue = null;
            (() => {
                if(ModelUtils.isDefined(node)) {
                    this._nodePath = Library.createNodePath(node);
                }
                this._property = property;
                this._newValue = newValue;
            })();
        } else if(node === undefined && property === undefined && newValue === undefined) {
            let __args = arguments;
            super();
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._property===undefined) this._property = null;
            if(this._newValue===undefined) this._newValue = null;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._nodePath===undefined) this._nodePath = null;
            if(this._property===undefined) this._property = null;
            if(this._newValue===undefined) this._newValue = null;
            if(this._oldValue===undefined) this._oldValue = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangePropertyCommand] Executing.");
        let node : Node = this._nodePath.resolve(document);
        if(this.isNullOrUndefined(node)) {
            return;
        }
        this._oldValue = <T><any>NodeCompat.getProperty(node, this._property);
        NodeCompat.setProperty(node, this._property, this._newValue);
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangePropertyCommand] Reverting.");
        let node : Node = this._nodePath.resolve(document);
        if(this.isNullOrUndefined(node)) {
            return;
        }
        NodeCompat.setProperty(node, this._property, this._oldValue);
        this._oldValue = null;
    }
}
ChangePropertyCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ChangePropertyCommand";
ChangePropertyCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




